<template>
    <div class="companies">
        <heading title="Company List" tag="company-list-title">
            <export-button
                :fields="exportFields" profile-key="company" @export="exportList"/>
            <b-button v-if="canCreate"
                      variant="primary"
                      class="ml-3"
                      :to="{name:'companyCreate'}">
                New Company
                <b-icon-plus-square/>
            </b-button>
        </heading>
        <data-table ref="dataTable"
                    persistName="company-filter"
                    :show-filters="true"
                    :show-pager="true"
                    :get-items="getEntries"
                    v-model="filters"
                    :fields="fields">
            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key === 'actions'">
                    <b-button size="sm" variant="secondary"
                              class="mr-2"
                              :to="{ name: 'companyView', params: { companyId : slotProps.row.item.id }}">
                        <b-icon-eye/>
                    </b-button>
                </div>
                <div v-else-if="slotProps.row.field.key === 'companyProjectCount'">
                    {{ slotProps.row.item.companyProjectCount }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'companyUserCount'">
                    {{ slotProps.row.item.companyUserCount }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'equipmentCount'">
                    {{ slotProps.row.item.equipmentCount }}
                </div>
                <div v-else-if="slotProps.row.field.key === 'status'">
                    {{ getStatusLabel(slotProps.row.item.status) }}
                </div>
            </template>
        </data-table>
    </div>
</template>

<script>
import Vue from 'vue'
import Company from '@/models/Company'
import Authorization from '@/providers/Authorization'
import Export from '@/providers/Export'
import * as _ from 'lodash'

export default Vue.extend({
    name: 'Companies',
    data () {
        return {
            fields: [
                { key: 'id', sortable: true, label: 'ID' },
                { key: 'name', sortable: true, label: 'Name' },
                { key: 'companyProjectCount', sortable: true, label: '# Projects' },
                { key: 'companyUserCount', sortable: true, label: '# Contractors' },
                { key: 'equipmentCount', sortable: true, label: '# Equipment' },
                { key: 'auditViolationCount', sortable: false, label: '# Audit Violations' },
                { key: 'outstandingExemptionCount', sortable: false, label: 'Oustanding Exemption Requests' },
                { key: 'cobid_type', sortable: true, label: 'COBID Type' },
                { key: 'status', sortable: true, label: 'Status' },
                { key: 'actions', sortable: false },
            ],

            exportFields: {
                name: 'Company Name',
                ccb_number: 'CCB License #',
                alt_license_type: 'Alt Oregon License Type',
                alt_license_number: 'Alt License #',
                url: 'URL',
                status: 'Status',
                equipmentCount: '# of Equipment',
                companyUserCount: '# of Users',
                companyProjectCount: '# of Projects',
                auditNoIssueCount: '# of Audits with No Issues',
                auditIssueCount: '# of Audits with Issues',
                auditViolationCount: '# of Audits with Violations',
                auditResolvedCount: '# of Resolved Audits',
                totalExemptionCount: 'Total # of Exemptions',
                pendingExemptionCount: '# of Pending Exemptions',
                draftExemptionCount: '# of Drafted Exemptions',
                grantedExemptionCount: '# of Granted Exemptions',
                deniedExemptionCount: '# of Denied Exemptions',
                mailing_address: 'Mailing Address',
                city: 'City',
                state: 'State',
                zip: 'Zip',
                cobid_certified: 'COBID Certified',
                cobid_number: 'COBID #',
                cobid_type: 'COBID type',
                contact_first_name: 'Contact First Name',
                contact_last_name: 'Contact Last Name',
                contact_email: 'Contact Email',
                contact_phone_office: 'Contact Phone (Office)',
                contact_phone_mobile: 'Contact Phone (Mobile)'
            },

            filters: {
                name: { field: 'name', type: 'string', value: null, label: 'Company Name' },
                status: {
                    field: 'status',
                    type: 'select',
                    options: ['ENABLED', 'DISABLED'],
                    value: null,
                    label: 'Status'
                }
            },
            canCreate: false,
        }
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'company', this.filters, listParams)
        },
        getStatusLabel (value) {
            return Company.getStatusLabel(value)
        },
        async exportList (type, fields) {
            //  context
            const contextTable = this.$refs.dataTable.getContext()
            const context = contextTable ? {sortBy: contextTable.sortBy, perPage: 100000, currentPage: 1} : null
            this.$api.getItems(this, 'company', this.filters, context, ['companyAdminUser'])
                .then((companies) => 
                {
                    //  map companyAdminUser fields
                    _.each(companies, (company) => {
                        if (company.companyAdminUser) {
                            let companyAdminUser = company.companyAdminUser;
                            company.contact_first_name = companyAdminUser.first_name;
                            company.contact_last_name = companyAdminUser.last_name;
                            company.contact_email = companyAdminUser.email;
                            company.contact_phone_office = companyAdminUser.phone_office;
                            company.contact_phone_mobile = companyAdminUser.phone_mobile;
                        }
                    })

                    // callback for status label
                    let callback = (key, value) => {
                        switch (key) {
                            case 'status':
                                value = this.getStatusLabel(value)
                                break
                        }
                        return value
                    }
                    //  export

                    Export.exportRecords(companies, fields, 'Companies', type, callback)
                })
        }
    },
    created () {
        Authorization.can({ action: 'create', model: 'company' })
            .then((can) => this.canCreate = can)
    },
})
</script>
